import { Link } from "react-router-dom";

type Action = {
  label: string;
  onClick?: () => void;
  to?: string;
  variant?: "primary" | "ghost";
};

type Props = {
  icon?: string;
  title: string;
  description: string;
  actions?: Action[];
};

export default function EmptyState({
  icon = "ri-search-eye-line",
  title,
  description,
  actions = [],
}: Props) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-background-200 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      {actions.length > 0 && (
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {actions.map((action) =>
            action.to ? (
              <Link
                key={action.label}
                to={action.to}
                className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-4 py-2 text-sm font-label transition-colors duration-200 ${
                  action.variant === "ghost"
                    ? "border border-background-300 bg-background-50 text-foreground-800 hover:border-primary-300 hover:text-primary-600"
                    : "bg-primary-500 text-background-50 hover:bg-primary-600"
                }`}
              >
                {action.label}
              </Link>
            ) : (
              <button
                key={action.label}
                type="button"
                onClick={action.onClick}
                className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-4 py-2 text-sm font-label transition-colors duration-200 cursor-pointer ${
                  action.variant === "ghost"
                    ? "border border-background-300 bg-background-50 text-foreground-800 hover:border-primary-300 hover:text-primary-600"
                    : "bg-primary-500 text-background-50 hover:bg-primary-600"
                }`}
              >
                {action.label}
              </button>
            ),
          )}
        </div>
      )}
    </div>
  );
}